import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BulkSelectionMessagesComponent } from '@core/user-interface-legacy';

import { BulkActionsController } from '../bulk-actions.controller';
import { BulkActionsSelectionTracker } from '../bulk-actions.selection-tracker';

@Component({
  selector: 'rt-bulk-actions-selection-message',
  templateUrl: './bulk-actions-selection-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BulkSelectionMessagesComponent],
})
export class BulkActionsSelectionMessageComponent {
  private readonly bulkCtrl = inject(BulkActionsController);
  private readonly tracker = inject(BulkActionsSelectionTracker);
  protected readonly cdRef = inject(ChangeDetectorRef);

  public readonly hasBottomMargin = input<boolean>(true);
  public readonly hasTopMargin = input<boolean>(true);

  public totalSelectedCount = 0;
  public currentViewSelectedCount = 0;

  private ngOnDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.tracker.state$.pipe(takeUntil(this.ngOnDestroy$.asObservable())).subscribe(state => {
      this.totalSelectedCount = state.totalSelectedCount;
      this.currentViewSelectedCount = state.currentViewSelectedCount;
      this.cdRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public handleSelectionClear(): void {
    this.bulkCtrl.clearSelection();
  }
}
